var render = function (_h,_vm) {var _c=_vm._c;return _c('pre',[_vm._v(_vm._s(_vm.props))])}
var staticRenderFns = []

export { render, staticRenderFns }